import { createEnvironment, initEnvironment } from './environment.factory';

export const environment = createEnvironment(false);
export { initEnvironment };